import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearchByDeptId,
  setSearchByDeptName,
} from "../../../../Redux/Actions/skill_matrix_actions";

const SearchComponent = () => {
  const { departments } = useSelector((state) => state.skillMatrix);
  const dispatch = useDispatch();
  const initialValues = {
    groupName: "",
    dept_id: "",
  };
  const [values, setValues] = useState(initialValues);

  const { groupName, dept_id } = values;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSearch = () => {
    if (!groupName && !dept_id) {
      dispatch(setSearchByDeptName(groupName));
      dispatch(setSearchByDeptId(dept_id));
    }
    if (groupName && dept_id) {
      dispatch(setSearchByDeptName(groupName));
      dispatch(setSearchByDeptId(dept_id));
    }
    if (groupName) dispatch(setSearchByDeptName(groupName));
    if (dept_id) dispatch(setSearchByDeptId(dept_id));
  };

  return (
    <div className="dash_white_box2 mb20 p20">
      <div className="dash_white_box_ttl">Search</div>
      <div className="row mb10">
        <div className="col-lg-3 col-md-6 pr07">
          <label className="form-label">Skill Name</label>
          <input
            type="text"
            className="form-control"
            value={groupName}
            name="groupName"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3 col-md-6 pl07 pr07">
          <label className="form-label">Department</label>
          <div className="form-input">
            <select
              className="form-select"
              name="dept_id"
              value={dept_id}
              onChange={handleChange}
            >
              <option value={""}>Select Department </option>
              {departments &&
                departments.map((dept, i) => {
                  return (
                    <option key={i} value={dept.id}>
                      {dept.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 pr07">
          <label className="h49"></label>
          <button onClick={handleSearch} className="btn_5">
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
